<template>
  <div>
    <div class="wrapper flex flex-between">
      <div>
        <breadcrumb :crumbs="[$t('reworkTypes.purchase')]"></breadcrumb>
      </div>
      <div class="page-tabs">
        <router-link to="/normal/pms/purchases">{{
          $t("menu.purchases")
        }}</router-link>
        <el-divider direction="vertical"></el-divider>
        <router-link to="/normal/pms/purchases/rework" class="active"
          >{{ $t("reworkTypes.purchase") }}({{ unFinishCount }})</router-link
        >
      </div>
      <div>
        <div style="width: 264px; height: 28px"></div>
        <!-- 占位 -->
      </div>
    </div>

    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('rework.remark')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.supplierId"
            filterable
            clearable
            :placeholder="$t('menu.suppliers')"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createdAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.entity == 'Order'"
              class="blue"
              @click="showRecordOrder(row)"
            >
              {{ row.entitySerialNo }}
            </span>
            <span
              v-if="row.entity == 'Purchase'"
              class="blue"
              @click="showRecordOurchase(row)"
            >
              {{ row.entitySerialNo }}
            </span>
            <span v-if="!['Order', 'Purchase'].includes(row.entity)">
              {{ row.entitySerialNo }}
            </span>

            <div class="font10">
              {{ $t("text.type") }}：{{ $t("reworkTypes." + row.type) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />
        <vxe-table-column
          field="remark"
          :title="$t('rework.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <thumbnail-text
              v-if="row.voucher != null"
              :srcs="row.voucher"
              :text="'凭证'"
            />
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="8"
                type="richText"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('rework.finisherName')" min-width="100">
          <template v-slot="{ row }">
            {{ row.finisherName }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="110"
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
            <div
              v-if="row.markFinishAt == null || row.finishAt == null"
              :class="
                Util.dateDiff(row.handOverAt, new Date()) > 0 ? '' : 'red'
              "
              class="font10"
            >
              {{ $t("text.handOverAtDateMinus")
              }}{{ Util.dateDiff(row.handOverAt, new Date()) }}天
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.ownerName }}
            <div class="font10">{{ row.shopName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="handle"
          :title="$t('text.handle')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.handle }}
            <div class="font10">{{ row.handleDept }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="markFinishAt"
          :title="$t('rework.markFinishAt')"
          min-width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="showOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowId" />
    </drawer>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showPurchaseDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-purchase :id="currentRowId" />
    </drawer>
  </div>
</template>

<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import ThumbnailText from "@/components/ThumbnailText";
import Rework from "@/api/rework.js";
import Supplier from "@/api/supplier.js";
import ShowOrder from "@/views/oms/bargains/showOrder.vue";
import ShowPurchase from "@/views/pms/purchases/show.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Thumbnail,
    RawHtmlLimitNumber,
    ThumbnailText,
    ShowOrder,
    ShowPurchase,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "reworks_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        handOverAt: "purchases_handOverAt",
      },
      narrows: [
        [
          {
            label: this.$t("rework.reworkInfo"),
            items: [
              {
                label: this.$t("reworkInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("reworkInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
        // [
        //   {
        //     label: this.$t("text.type"),
        //     items: Rework.types_all.map((type) => {
        //       return {
        //         label: this.$t("reworkTypes." + type),
        //         key: type,
        //         condition: { type: type },
        //       };
        //     }),
        //   },
        // ],
      ],
      initFilter: "no",
      searchForm: {
        productNo: null,
        remark: null,
        createAtStartAt: null,
        createAtEndAt: null,
        supplierId: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        handle: null,
      },
      suppliers: [],
      //
      currentRowId: null,
      showOrderDF: false,
      showPurchaseDF: false,
      unFinishCount: 0,
    };
  },
  computed: {
    implicit() {
      return {
        owner: "yes",
        type: "purchase",
      };
    },
  },
  created() {
    const self = this;
    self.getSuppliers();
    Rework.unFinishPurchaseCount().then(function (res) {
      if (res.status == 200) {
        self.unFinishCount = res.data;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    getSuppliers() {
      const self = this;
      Supplier.findByTenantId(self.Permit.currentTenant().id).then(function (
        res
      ) {
        if (res.status === 200) {
          self.suppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    showRecordOrder(row) {
      this.currentRowId = row.entityId;
      this.showOrderDF = true;
    },
    showRecordOurchase(row) {
      this.currentRowId = row.entityId;
      this.showPurchaseDF = true;
    },
    //
    dataProvider(params) {
      return Rework.search(params);
    },
  },
};
</script>
